// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__L7onV","range":"MonthRangeSwitch_range__AwAfx","disabled":"MonthRangeSwitch_disabled__2MijX"};